<template>
    <div class="tab">
   <div class="tab_item" v-for="(item ,index) in tabBarImg" :key="index" @click="switchToTab(item.path)">
       <div class="tabbar">
         <span v-if="index === 1 && item.count > 0">{{item.count}}</span>
         <img :src="$route.path === item.path ? item.icon : item.normal" alt="">
       </div>
       <div>
         <span :class="$route.path === item.path ? 'actives' : ''">{{item.title}}</span>
       </div>
   </div>
 </div>
</template>
<script>
export default {
    name: "Tabbar",
    data(){
      return{
        tabBarImg:[
          {
            path:'/',
            normal:require('../assets/images/TabBar/index.png'),
            icon:require('../assets/images/TabBar/indexhover.png'),
            title:'主页'
          },
          {
             path:'/chat',
             normal:require('../assets/images/TabBar/message.png'),
             icon:require('../assets/images/TabBar/messagehover.png'),
             title:'消息',
             count: 0,
           },
          {
            path:'/me',
            normal:require('../assets/images/TabBar/im.png'),
            icon:require('../assets/images/TabBar/imhover.png'),
            title:'我的'
          },
        ]
      }
    },
    created() {
      //在mixin中vue的data、生命周期、方法等都可以使用
      window.addEventListener('setItemEvent',  (e) => {
        if (e.key === "allUnReadTotal") {
          this.tabBarImg[1].count = e.newValue;
        }
      })
    },
    methods:{
      switchToTab(path){
        this.$router.replace(path);
      }
    }
  }
</script>
<style scoped='scoped'>
.tab{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    display: flex;
    background: #FFFFFF;
    justify-content: center;
    text-align: center;
    z-index: 999;
}
.tab_item{
    width: 33.33%;
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 22px;
    color: #999999;
}
.tabbar{
    width: 44px;
    height: 44px;
    display: inline-block;
    margin-bottom: 10px;
    position: relative;
}
.tabbar span{
  position: absolute;
  left: 24px;
  top: -18px;
  display: inline-block;
  min-width: 22px;
  padding: 0 4px;
  height: 30px;
  line-height: 32px;
  border-radius: 50px;
  text-align: center;
  background: #FF4032;
  font-size: 20px;
  border: 4px solid white;
  color: white;
}
.tabbar img{
    width: 100%;
}
.actives{
    color: #333333;
    margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue